<template>
  <Dialog
    v-model="dialog"
    textBtn="新規登録"
    :width="500"
    classBtn="ml-2"
    title="タブ登録"
    closable
  >
    <template v-slot:content>
      <v-row v-for="(item, index) in lang" :key="index">
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          v-model="name[item.key]"
          v-if="item.key == 'ja'"
          :error-messages="nameErrors"
          @input="$v.name.ja.$touch()"
          @blur="$v.name.ja.$touch()"
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ item.text }}</span>
            <span class="red--text" v-if="item.key == 'ja'">*</span>
          </template>
        </v-textarea>
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          :label="item.text"
          v-model="name[item.key]"
          v-else
        >
          <template v-slot:label>
            <span class="font-weight-bold mr-1">{{ item.text }}</span>
          </template>
        </v-textarea>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn
        :disabled="loading"
        color="primary"
        :loading="loading"
        @click="handleCreateTab"
        >{{ $t("REGISTER") }}</v-btn
      >
      <v-btn class="ml-10" @click="dialog = false">{{ $t("CANCEL") }}</v-btn>
      <v-spacer />
    </template>
  </Dialog>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { createTab } from "@/api/Tab.api";
import Dialog from "@/components/Dialog/Dialog";

export default {
  components: {
    Dialog,
  },
  mixins: [validationMixin],
  data() {
    return {
      lang: [
        { text: "日本語", key: "ja" },
        { text: "日本語（かな）", key: "kana" },
        { text: "英語", key: "en" },
        { text: "中国語", key: "cn" },
        { text: "ベトナム語", key: "vn" },
        { text: "ベンガル語", key: "bn" },
        { text: "ポルトガル語", key: "pt" },
      ],
      name: { ja: "", kana: "", en: "", cn: "", vn: "", bn: "", pt: "" },
      dialog: false,
      loading: false,
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.ja.$dirty) return errors;
      !this.$v.name.ja.required && errors.push("日本語を入力してください。");
      return errors;
    },
  },
  validations() {
    return {
      name: {
        ja: {
          required,
        },
      },
    };
  },
  watch: {
    dialog: function() {
      this.name = { ja: "", kana: "", en: "", cn: "", vn: "", bn: "", pt: "" };
      this.$v.$reset();
    },
  },
  methods: {
    async handleCreateTab() {
      this.$v.$touch();
      if (!this.$v.$anyError) {
        const { name } = this;
        let params = {
          name,
        };
        this.loading = true;
        await createTab(params)
          .then(async () => {
            this.loading = false;
            this.$emit("resetList");
            this.dialog = false;
          })
          .catch((error) => {
            this.$toast.error(error);
            this.loading = false;
          });
      }
    },
    handleCancel() {
      this.$emit("resetList");
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.pad-top-bottom {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
